import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setAnsweringInfoAction } from "../../../../redux/answeringQuestions/answeringInfo";

const QuestionCountAccentor = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const dispatch = useDispatch();
  const setAnsweringInfo = payload => { dispatch( setAnsweringInfoAction( payload ) ) };

  useEffect( () => {
    if ( answeringQuestions.isAccentQuestionCount ) {
      const zoomIn = () => {
        setAnsweringInfo( { questionCountAccentClassName : 'num-ani' } );
        timer = setTimeout( zoomOut, 1000 );
      };
      const zoomOut = () => {
        setAnsweringInfo( { questionCountAccentClassName : '' } );
      };
      let timer = setTimeout( zoomIn );
      return () => {
        clearTimeout( timer );
      };
    }
  }, [ answeringQuestions.isAccentQuestionCount ] );

  return props.children || null;

};

export default QuestionCountAccentor;
